<script>
import { ArrowUpIcon } from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";
import Testimonial from "@/components/testimonial";
import CommonInput from "@/components/input";
import CommonButton from "@/components/button";
import CommonRadio from "@/components/radio";
import { partnerApi } from '@/api'
import { Select, Input, FormModel, Form, Radio, DatePicker, Checkbox, Switch, Upload, Row, Col, Button, Icon, Modal, Spin, InputNumber } from 'ant-design-vue'

import i18n from '@/i18n'

/**
 * Page-services component
 */
export default {
  name: 'ChannelPartner',
  data () {
    return {
      formData: {
        company: "",
        code: "",
        address: "",
        name: '',
        phone: '',
        legalName: "",
        isController: 1,
        idFront: '',
        idBack: '',
        license: '',
        audit: '',
        notes: '',
      },
      imgMap: {
        idFront: '',
        idBack: '',
        idFrontFileList: [],
        idBackFileList: [],
        license: '',
        audit: '',
        licenseFileList: [],
        auditFileList: [],
      },
      uploadLoading: {
        idFront: false,
        idBack: false,
        license: false,
        audit: false,
      },
      loading: false,
      previewVisible: false,
      previewImage: '',
      step: 1,
      checkedPay: 1,
      pk: process.env.VUE_APP_PK,
      testMode: process.env.VUE_APP_testMode === 'true',
      elementsOptions: {
        appearance: {}, // appearance options
      },
      confirmParams: {
        return_url: location.origin + '/top-up', // success url
      },
      createOptions: {
        metadata: {}
      },
      buyLoading: false,
      elementLoading: true,
      chargeLoading: false,
      queryParams: {},
      isResult: false,
      isPaySuccess: false,
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  components: {
    Navbar,
    Switcher,
    Footer,
    Carousel,
    Testimonial,
    Slide,
    ArrowUpIcon,
    CommonInput,
    CommonButton,
    CommonRadio,
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-form': FormModel,
    'a-form-item': FormModel.Item,
    'a-input': Input,
    'a-radio': Radio,
    'a-radio-group': Radio.Group,
    'a-date-picker': DatePicker,
    'a-checkbox': Checkbox,
    'a-checkbox-group': Checkbox.Group,
    'a-switch': Switch,
    'a-upload': Upload,
    'a-row': Row,
    'a-col': Col,
    'a-button': Button,
    'a-icon': Icon,
    'a-modal': Modal,
    'a-spin': Spin,
    'a-input-number': InputNumber,
  },
  mounted () {
    if (!localStorage.getItem('token')) {
      this.$router.push('/auth-login')
      this.$message.warning(this.$t('请登录后进行操作'))
    }
  },
  methods: {
    handleSubmit () {
      function cloneFile(originalFile) {
        return new File([originalFile], originalFile.name, {
          type: originalFile.type,
          lastModified: originalFile.lastModified,
        });
      }
      this.$refs.form.validate().then(() => {
        this.loading = true
        const formData = new FormData()
        const file1 = cloneFile(this.formData.idFront)
        delete file1.url
        const file2 = cloneFile(this.formData.idBack)
        delete file2.url
        const file3 = cloneFile(this.formData.license)
        delete file3.url
        const file4 = cloneFile(this.formData.audit)
        delete file4.url
        formData.append('idFront', file1);
        formData.append('idBack', file2);
        formData.append('license', file3);
        formData.append('audit', file4);
        partnerApi(formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {
            company: this.formData.company,
            code: this.formData.code,
            address: this.formData.address,
            name: this.formData.name,
            phone: this.formData.phone,
            legalName: this.formData.legalName,
            isController: this.formData.isController,
            notes: this.formData.notes,
          }
        }).then(() => {
          this.loading = false
          this.$message.success(this.$t('信息已提交，请等待审核'))
          // this.$nextTick(() => {
          //   this.pay()
          // })
        }).catch(err => {
          this.$message.error(err.message || err.msg || err)
        }).finally(() => {
          console.log('3333')
          this.loading = false
        })
      })
    },
    handleUpload (type, file) {
      // Logic for handling file upload
      if (file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error(this.$t('文件大小不能超过 5MB!'));
          return false
        }

        const reader = new FileReader();
        this.$set(this.uploadLoading, type, true)

        // 加载完成后回调
        reader.onload = (e) => {
          console.log(e)
          this.$set(this.imgMap, type, e.target.result)
          file.url = e.target.result
          this.$set(this.imgMap, type + 'FileList', Array.isArray(file) ? file.slice(-1) : [file])
          this.$set(this.uploadLoading, type, false)
          this.$set(this.formData, type, Array.isArray(file) ? file[file.length - 1] : file)
        };

        reader.readAsDataURL(file); // 将文件读取为 Data URL（Base64 格式）
      }
      return false; // Prevent auto-upload
    },
    handleRemove (type, file) {
      this.$set(this.imgMap, type + 'FileList', [])
      this.$set(this.formData, type, '')
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleChange (field, e) {
      if (e.fileList.length) {
        this.$refs.form.clearValidate(field);
      } else {
        this.$refs.form.validateField(field);
      }
    },
    dateChange (e) {
      this.$refs.form.validateField('expiration');
    },
    async handlePreview (file) {
      // if (!file.url && !file.preview) {
      //   file.preview = await getBase64(file.originFileObj);
      // }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
  }
};
</script>

<template>
  <div class="bg-home">
    <a-modal :visible="previewVisible" :title="$t('预览图片')" :footer="null" @cancel="handleCancel">
      <img style="width: 100%" :src="previewImage" />
    </a-modal>

    <Navbar isWhiteNavbar />

    <section class="section min-h">
      <div class="top-bar">
        <div class="container">
          <div class="top-bar-title text-center">
            {{ $t('渠道商资格申请(企业专用)') }}
          </div>
        </div>
      </div>

      <div
        class="top-up-card"
      >
      <a-form
        :layout="'vertical'"
        ref="form"
        :model="formData"
        @submit.prevent="handleSubmit"
      >
        <!-- Personal Information -->
        <div class="form-item-title d-flex justify-between">
          <span>
            {{ $t('企业基本信息填写') }}
          </span>

          <router-link to="/channel-submit-history" class="router-link-custom">{{ $t('提交记录') }}</router-link>
        </div>
        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="24"
          >
            <a-form-item
              :label="$t('企业名称')"
              prop="company"
              :rules="[{ required: true, trigger: 'blur', message: $t('请输入企业名称') }]"
            >
              <a-input
                v-model="formData.company"
                size="large"
                :placeholder="$t('请输入企业名称')"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="24"
          >
            <a-form-item
              :label="$t('统一社会信用代码')"
              prop="code"
              :rules="[{ required: true, trigger: 'blur', message: $t('请输入统一社会信用代码') }]"
            >
              <a-input
                v-model="formData.code"
                size="large"
                :placeholder="$t('请输入统一社会信用代码')"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="24"
          >
            <a-form-item
              :label="$t('注册地址')"
              prop="address"
              :rules="[{ required: true, trigger: 'blur', message: $t('请输入注册地址') }]"
            >
              <a-input
                v-model="formData.address"
                size="large"
                :placeholder="$t('请输入注册地址')"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="12"
          >
            <a-form-item
              :label="$t('企业联系人姓名')"
              prop="name"
              :rules="[{ required: true, trigger: 'blur', message: $t('请输入企业联系人姓名') }]"
            >
              <!-- <a-date-picker
                v-model="formData.dob"
                style="width: 100%"
                placeholder="YYYY-MM-DD"
              /> -->
              <a-input v-model="formData.name" size="large" :placeholder="$t('请输入企业联系人姓名')"></a-input>
            </a-form-item>
          </a-col>
          <a-col
            :xs="24"
            :sm="12"
          >
            <a-form-item
              :label="$t('联系电话')"
              prop="phone"
              :rules="[{ required: true, trigger: 'blur', message: $t('请输入联系电话') }]"
            >
              <a-input
                v-model="formData.phone"
                size="large"
                :placeholder="$t('请输入联系电话')"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="form-item-title">{{ $t('法人信息上传') }}</div>

        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="24"
          >
            <a-form-item
              :label="$t('法人姓名')"
              prop="legalName"
              :rules="[{ required: true, trigger: 'blur', message: $t('请输入法人姓名') }]"
            >
              <a-input
                v-model="formData.legalName"
                size="large"
                :placeholder="$t('请输入法人姓名')"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :xs="24" :sm="12">
            <a-form-item
              :label="$t('证件照片(正面)')"
              prop="idFront"
              :rules="[{ required: true, trigger: 'blur', message: $t('请上传证件正面') }]"
            >
                <!-- accept="image/jpeg, image/png, image/webp, image/svg+xml" -->
                <a-upload
                  accept="image/jpeg, image/png, image/webp, image/svg+xml"
                  :file-list="imgMap.idFrontFileList"
                  :before-upload="file => handleUpload('idFront', file)"
                  list-type="picture-card"
                  :show-upload-list="true"
                  @preview="handlePreview"
                  :remove="file => handleRemove('idFront', file)"
                  @change="handleChange('idFront', $event)""
                >
                <div v-if="imgMap.idFrontFileList.length < 1">
                  <img v-if="formData.idFront" :src="imgMap.idFront" alt="avatar" />
                  <div v-else>
                    <a-icon :type="uploadLoading.idFront ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </div>
              </a-upload>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item
              :label="$t('证件照片(背面)')"
              prop="idBack"
              :rules="[{ required: true, trigger: 'blur', message: $t('请上传证件背面') }]"
            >
                <!-- accept="image/jpeg, image/png, image/webp, image/svg+xml" -->
                <a-upload
                  accept="image/jpeg, image/png, image/webp, image/svg+xml"
                  :file-list="imgMap.idBackFileList"
                  :before-upload="file => handleUpload('idBack', file)"
                  list-type="picture-card"
                  :show-upload-list="true"
                  @preview="handlePreview"
                  :remove="file => handleRemove('idBack', file)"
                  @change="handleChange('idBack', $event)"
                >
                <div v-if="imgMap.idBackFileList.length < 1">
                  <img v-if="formData.idBack" :src="imgMap.idBack" alt="avatar" />
                  <div v-else>
                    <a-icon :type="uploadLoading.idBack ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </div>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :xs="24" :sm="12">
            <a-form-item
              :label="$t('营业执照')"
              prop="license"
              :rules="[{ required: true, trigger: 'blur', message: $t('请上传营业执照') }]"
            >
                <!-- accept="image/jpeg, image/png, image/webp, image/svg+xml" -->
                <a-upload
                  accept="image/jpeg, image/png, image/webp, image/svg+xml, application/pdf"
                  :file-list="imgMap.licenseFileList"
                  :before-upload="file => handleUpload('license', file)"
                  list-type="picture-card"
                  :show-upload-list="true"
                  @preview="handlePreview"
                  :remove="file => handleRemove('license', file)"
                  @change="handleChange('license', $event)""
                >
                <div v-if="imgMap.licenseFileList.length < 1">
                  <img v-if="formData.license" :src="imgMap.license" alt="avatar" />
                  <div v-else>
                    <a-icon :type="uploadLoading.license ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </div>
              </a-upload>
            </a-form-item>
          </a-col>

          <a-col :xs="24" :sm="12">
            <a-form-item
              :label="$t('财务审计报告')"
              prop="audit"
              :rules="[{ required: true, trigger: 'blur', message: $t('请上传财务审计报告') }]"
            >
                <!-- accept="image/jpeg, image/png, image/webp, image/svg+xml" -->
                <a-upload
                  accept="image/jpeg, image/png, image/webp, image/svg+xml, application/pdf"
                  :file-list="imgMap.auditFileList"
                  :before-upload="file => handleUpload('audit', file)"
                  list-type="picture-card"
                  :showUploadList="{ showPreviewIcon: false }"
                  :show-upload-list="true"
                  @preview="handlePreview"
                  :remove="file => handleRemove('audit', file)"
                  @change="handleChange('audit', $event)""
                >
                <div v-if="imgMap.auditFileList.length < 1">
                  <img v-if="formData.audit" :src="imgMap.audit" alt="avatar" />
                  <div v-else>
                    <a-icon :type="uploadLoading.audit ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </div>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>

        <div class="form-item-title">{{ $t('额外声明与确认') }}</div>
        <a-form-item :label="$t('法人是否为实际控制人')" required>
          <a-radio-group v-model="formData.isController" size="large">
            <a-radio class="flex-1 text-center" :value="1">
              {{ $t('是') }}
            </a-radio>
            <a-radio class="flex-1 text-center" :value="0">
              {{ $t('否') }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          :label="$t('补充说明(可选)')"
          prop="name"
        >
          <a-input
            v-model="formData.notes"
            size="large"
            type="textarea"
            :placeholder="$t('请输入补充说明')"
          />
        </a-form-item>

        <a-form-item>
          <a-button
            :loading="loading"
            class="primary custom-button w-100"
            html-type="submit"
          >
            {{ $t('提交') }}
          </a-button>
        </a-form-item>
      </a-form>
      </div>
    </section>

    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style lang="scss" scoped>
.form-item-title {
  font-size: 20px;
  color: #1A1B21;
  margin-bottom: 12px;
}

.checked {
  border: 1px solid #2f55d4;
}

.left-4 {
  left: 16px;
}

.top-up-card {
  max-width: 650px;
  margin: 40px auto 0;
  padding: 32px;
  border-radius: 16px;
  background-color: #FFFFFF;
  border: 2px solid;
  border-image-source: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  backdrop-filter: blur(20.799999237060547px)
}

.router-link-custom {
  font-size: 14px;
  color: #2f55d4;
}

@media screen and (max-width: 500px) {
  .top-up-card {
    padding: 16px;
  }
}
</style>
